import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { style: {"width":"60%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('guidance.formTemplateSettings')), 1),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditDialog())),
        disabled: _ctx.loading,
        color: "primary",
        variant: "flat"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.create')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_data_table, {
        headers: _ctx.headers,
        items: _ctx.formResponse ? _ctx.formResponse.data : [],
        loading: _ctx.loading,
        "hide-default-footer": "",
        "items-per-page": -1
      }, {
        [`item.type`]: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.getPlanText(item.type)), 1)
        ]),
        [`item.createdAt`]: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(item.createdAt)), 1)
        ]),
        [`item.edit`]: _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            onClick: ($event: any) => (_ctx.openEditDialog(item)),
            disabled: _ctx.loading,
            color: "primary",
            variant: "outlined",
            small: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        [`item.delete`]: _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            onClick: ($event: any) => (_ctx.deleteForm(item.id)),
            disabled: _ctx.loading,
            color: "error",
            small: "",
            variant: "flat"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _: 2
      }, 1032, ["headers", "items", "loading"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editDialog) = $event)),
      "max-width": "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('guidance.formItems')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('guidance.templateName')) + "* ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.input.name,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.name) = $event)),
                              variant: "outlined",
                              "hide-details": "",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('guidance.type')) + "* ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.input.type,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input.type) = $event)),
                              items: _ctx.planItems,
                              variant: "outlined",
                              "hide-details": "",
                              density: "compact"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('guidance.formItems')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_table, null, {
                              default: _withCtx(() => [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('guidance.order')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('guidance.itemName')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('common.delete')), 1)
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.input.itemList, (item, i) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                      _createElementVNode("td", null, _toDisplayString(i + 1), 1),
                                      _createElementVNode("td", _hoisted_3, [
                                        _createVNode(_component_v_select, {
                                          modelValue: item.itemId,
                                          "onUpdate:modelValue": ($event: any) => ((item.itemId) = $event),
                                          items: _ctx.planFormItems,
                                          variant: "outlined",
                                          density: "compact",
                                          "hide-details": ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_v_btn, {
                                          onClick: ($event: any) => (_ctx.deleteItemInItemList(i)),
                                          color: "error",
                                          variant: "outlined",
                                          small: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _ctx.AddItemToItemList,
                              disabled: _ctx.loading,
                              color: "primary",
                              variant: "outlined",
                              small: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                    _createTextVNode("mdi-plus", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('guidance.addItem')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editDialog = false)),
                          color: "grey",
                          text: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        (_ctx.isUpdate)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _ctx.updateForm,
                              disabled: _ctx.loading,
                              color: "primary",
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"]))
                          : (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              onClick: _ctx.createForm,
                              disabled: _ctx.loading,
                              color: "primary",
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.create')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}